import { PREFIX } from "../../constant";

export class TooltipHandlerType {}

TooltipHandlerType.dom = `${PREFIX}_TOOLTIP_HANDLER_DOM`, TooltipHandlerType.canvas = `${PREFIX}_TOOLTIP_HANDLER_CANVAS`;

export const TOOLTIP_EL_CLASS_NAME = "vchart-tooltip-element";

export const TOOLTIP_MAX_LINE_COUNT = 20;

export const TOOLTIP_OTHERS_LINE = {
    key: "其他",
    value: "..."
};
//# sourceMappingURL=constant.js.map
